import React from "react"
import { FormSelect } from "react-ame-components"
import ShowCase from "../components/Showcase"

export class FormSelectExample extends React.Component {
  options = [
    {
      label: "teste 1",
      value: "teste 1",
    },
    {
      label: "teste 2",
      value: "teste 2",
    },
    {
      label: "teste 3",
      value: "teste 3",
    },
    {
      label: "teste 4",
      value: "teste 4",
    },
    {
      label: "teste 5",
      value: "teste 5",
    },
    {
      label: "teste 6",
      value: "teste 6",
    },
  ]
  render() {
    return (
      <ShowCase
        title="Componente Form Select"
        description="Componente para selecionar um item entre uma coleção">
        <FormSelect
          label="Um Label"
          options={this.options}
          placeholder="Selecione Aqui"
          keySelectLabel="label"
          onChange={e => console.log("selected: ", e)}
        />
      </ShowCase>
    )
  }
}
